"use strict";
/**
 * Created by Pankaj on 2019-12-18.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NolimitWinnersController = void 0;
const NolimitWinnersView_1 = require("./NolimitWinnersView");
const NolimitPromotionPlugin_1 = require("../../NolimitPromotionPlugin");
const PromoPanelButtonIDs_1 = require("../../enums/PromoPanelButtonIDs");
const GuiButton_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton");
const Communication_1 = require("../../communication/Communication");
const PromoPanelConfig_1 = require("../../config/PromoPanelConfig");
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
const ReplayFilterTypes_1 = require("../../enums/ReplayFilterTypes");
class NolimitWinnersController {
    get promotionPlugin() {
        return this._promotionPlugin;
    }
    constructor(promotionPlugin, id) {
        this._isRequestCompleted = true;
        this._isCurrentGame = true;
        this._isXBet = true;
        this._isSinglePlayer = false;
        this.id = id;
        this.config = PromoPanelConfig_1.PromoPanelConfig.getFeatureConfig(id);
        this._promotionPlugin = promotionPlugin;
        this.init();
    }
    static makeIFrame(id) {
        const iFrame = document.createElement("iframe");
        iFrame.name = id;
        iFrame.style.width = "100%";
        iFrame.style.height = "100%";
        iFrame.style.position = "absolute";
        iFrame.style.zIndex = "2147483647";
        iFrame.style.overflow = "hidden";
        iFrame.style.backgroundColor = "black";
        iFrame.setAttribute("frameborder", "0");
        iFrame.setAttribute("allowfullscreen", "");
        iFrame.setAttribute("sandbox", "allow-forms allow-scripts allow-same-origin allow-top-navigation allow-popups");
        iFrame.setAttribute("allowfullscreen", "");
        iFrame.setAttribute("allow", "autoplay; fullscreen");
        iFrame.id = id;
        return iFrame;
    }
    init() {
        this._communication = new Communication_1.Communication(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn);
        this._view = new NolimitWinnersView_1.NolimitWinnersView(this);
    }
    open() {
        this._view.open();
        this.isCurrentGame ? this.buttonClick(new GuiButton_1.GuiButton(PromoPanelButtonIDs_1.PromoPanelButtonIDs.CURRENT_GAME_BTN), undefined, true) : this.buttonClick(new GuiButton_1.GuiButton(PromoPanelButtonIDs_1.PromoPanelButtonIDs.ALL_GAME_BTN), undefined, true);
    }
    close() {
        this._view && this._view.close();
    }
    buttonClick(button, featureData, isManualCall = false) {
        if (!this._isRequestCompleted) {
            return;
        }
        !isManualCall && NolimitPromotionPlugin_1.NolimitPromotionPlugin.sound.playKeypadEffect("click");
        switch (button.name) {
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.CURRENT_GAME_BTN:
                this.isCurrentGame = true;
                this.getData();
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.ALL_GAME_BTN:
                this.isCurrentGame = false;
                this.getData();
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.SINGLE_PLAYER_BTN:
                this.isSinglePlayer = true;
                this.getData();
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.ALL_PLAYER_BTN:
                this.isSinglePlayer = false;
                this.getData();
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.X_BET_FILTER_BTN:
                this.isXBet = true;
                this.getData();
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.X_WIN_FILTER_BTN:
                this.isXBet = false;
                this.getData();
                break;
            default:
                Logger_1.Logger.warn("Replay Controller Button click :: no case match : ", button);
        }
    }
    openReplay(replayUrl) {
        NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.openReplay(replayUrl);
    }
    /**
     * To get top 10 xWin data
     */
    getTopMonetaryData(operator) {
        this._isRequestCompleted = false;
        this._communication.getTopMonetaryData(operator).then((response) => {
            this._view.update(response.rounds);
            this._isRequestCompleted = true;
        }, (error) => {
            Logger_1.Logger.warn("ReplayController : promise reject data : ", error);
        });
    }
    /**
     * To get top 10 Xbet data of a specific game.
     * @param gameName
     * @param operator
     */
    getXBetGameSpecificData(gameName, operator) {
        this._isRequestCompleted = false;
        this._communication.getXBetGameSpecificData(gameName, operator).then((response) => {
            this._view.update(response.rounds);
            this._isRequestCompleted = true;
        }, (error) => {
            Logger_1.Logger.warn("ReplayController : promise reject data : ", error);
        });
    }
    /**
     * To get top 10 xWin data of a specific game.
     * @param gameName
     * @param operator
     */
    getMonetaryGameSpecificData(gameName, operator) {
        this._isRequestCompleted = false;
        this._communication.getMonetaryGameSpecificData(gameName, operator).then((response) => {
            this._view.update(response.rounds);
            this._isRequestCompleted = true;
        }, (error) => {
            Logger_1.Logger.warn("ReplayController : promise reject data : ", error);
        });
    }
    receiveMessage(event) {
        var _a;
        if (event.data === "exit-replay") {
            (_a = document.getElementById("replayIframe")) === null || _a === void 0 ? void 0 : _a.remove();
            NolimitPromotionPlugin_1.NolimitPromotionPlugin.sound.resume();
            if (this._replayGameWindow) {
                this._replayGameWindow.close();
                this._replayGameWindow = null;
            }
        }
    }
    /**
     * Function to get Replay data from API
     */
    getData() {
        //NolimitApplication.events.trigger(PromoPanelEvents.REPLAY_DATA_REQUEST_STARTED);
        this._view.update([]); //to clear all record
        this._view.playLoadingAnimation();
        const operator = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.options.operator;
        let gameName = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.options.game;
        gameName = gameName.replace(PromoPanelConfig_1.PromoPanelConfig.GAME_NAME_FILTER_REG_EXP, "");
        if (this.isCurrentGame) {
            if (this.isSinglePlayer) {
                this._isXBet ? this.getCurrentPlayerCurrentGameTopList(ReplayFilterTypes_1.ReplayFilterTypes.MULTIPLIER) : this.getCurrentPlayerCurrentGameTopList(ReplayFilterTypes_1.ReplayFilterTypes.MONETARY);
            }
            else {
                this._isXBet ? this.getXBetGameSpecificData(gameName, operator) : this.getMonetaryGameSpecificData(gameName, operator);
            }
        }
        else {
            if (this.isSinglePlayer) {
                this._isXBet ? this.getCurrentPlayerAllGameTopList(ReplayFilterTypes_1.ReplayFilterTypes.MULTIPLIER) : this.getCurrentPlayerAllGameTopList(ReplayFilterTypes_1.ReplayFilterTypes.MONETARY);
            }
            else {
                this._isXBet ? this.getTopXBetData(operator) : this.getTopMonetaryData(operator);
            }
        }
    }
    /**
     * To get Top List for current player and current game.
     */
    getCurrentPlayerCurrentGameTopList(type) {
        this._isRequestCompleted = false;
        this._communication.getTopListCurrentGame(type).then((response) => {
            this._view.update(response);
            this._isRequestCompleted = true;
        }, (error) => {
            Logger_1.Logger.warn("ReplayController : promise reject data : ", error);
        });
    }
    /**
     * To get Top List for current player and all game.
     */
    getCurrentPlayerAllGameTopList(type) {
        this._isRequestCompleted = false;
        this._communication.getTopListAnyGame(type).then((response) => {
            this._view.update(response);
            this._isRequestCompleted = true;
        }, (error) => {
            Logger_1.Logger.warn("ReplayController : promise reject data : ", error);
        });
    }
    /**
     * To get Top 10 xBet Data
     */
    getTopXBetData(operator) {
        this._isRequestCompleted = false;
        this._communication.getTopXBetData(operator).then((response) => {
            this._view.update(response.rounds);
            this._isRequestCompleted = true;
        }, (error) => {
            Logger_1.Logger.warn("ReplayController : promise reject data : ", error);
        });
    }
    get view() {
        return this._view;
    }
    set view(value) {
        this._view = value;
    }
    get isCurrentGame() {
        return this._isCurrentGame;
    }
    set isCurrentGame(value) {
        this._isCurrentGame = value;
        this._view.toggleButtons();
    }
    get isXBet() {
        return this._isXBet;
    }
    set isXBet(value) {
        this._isXBet = value;
        this._view.toggleButtons();
    }
    get isSinglePlayer() {
        return this._isSinglePlayer;
    }
    set isSinglePlayer(value) {
        this._isSinglePlayer = value;
        this._view.toggleButtons();
    }
}
exports.NolimitWinnersController = NolimitWinnersController;
//# sourceMappingURL=NolimitWinnersController.js.map